<script setup lang="ts">
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import StatusDot from "@/components/ui/StatusDot.vue";
import type { Status } from "@/model/status";

defineProps<{ status: Status }>();
</script>

<template>
  <div>
    <BaseTooltip position="bottom">
      <StatusDot :status-class="status.statusClass" />
      <template #content>{{ status.name }}</template>
    </BaseTooltip>
  </div>
</template>

<style lang="scss" scoped>
:deep(.status-dot) {
  height: 14px;
  width: 14px;
}
</style>
